import React from 'react';
import Container from '../container';
import RichtextParser from '../../utils/richtext-parser';
import styled from 'styled-components';
import parseStoryblokLink from '../../utils/parse-storyblok-link';
import { Link } from 'gatsby';

const CaseStudyCTAContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #161616;
  width: 100%;
  padding: 64px 32px;
  margin-bottom: 72px;
  border-radius: var(--Radius-Radius-3, 16px);
  overflow: hidden;
`;

const Title = styled.h2`
  color: #fff;
  text-align: center;
  font-size: 32px;
  font-style: normal;
  font-weight: 700;
  line-height: 120%;
  letter-spacing: -0.64px;
`;

const Description = styled.div`
  color: #c4c4c4;
  text-align: center;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 160%;
  letter-spacing: -0.4px;
  padding-top: 20px;
  padding-bottom: 46px;
`;

const Button = styled(Link)`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 56px;
  padding: 0 40px;
  background: #fff;
  color: #161616;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 140%;
  cursor: pointer;
  text-decoration: none;
`;

export default function CaseStudyCallToAction({
  title,
  description,
  callToActionLink,
  callToActionText
}: {
  title: string;
  description: any;
  callToActionLink: any;
  callToActionText: string;
}) {
  return (
    <Container>
      <CaseStudyCTAContainer>
        <Title>{title}</Title>
        <Description
          dangerouslySetInnerHTML={{ __html: RichtextParser(description) }}
        />
        <Button to={parseStoryblokLink(callToActionLink)}>
          {callToActionText}
        </Button>
      </CaseStudyCTAContainer>
    </Container>
  );
}
